import React, { useState } from "react";
import { FaWhatsappSquare, FaSms, FaTimes } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import CuInput from "../../all-patient/components/CuInput";
import CuButton from "../../all-patient/components/CuButton";

const Share = ({
  onClose,
  sendNotification,
  isLoading,
  handleSaveConsultation,
  isSendNotificationLoading,
}) => {
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [smsNumber, setSmsNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [prescription, setPrescription] = useState(
    "Your medical prescription is ready for pickup."
  );

  const handleChange = (e, type) => {
    if (type === "isWhatsapp" && e.target.value.length <= 10) {
      setWhatsappNumber(e.target.value);
    } else if (type === "isSMS" && e.target.value.length <= 10) {
      setSmsNumber(e.target.value);
    } else if (type === "isEmail") {
      setEmailAddress(e.target.value);
    }
  };

  const handleSendNotification = (type) => (e) => {
    e.preventDefault();
    const number = type === "isWhatsapp" ? whatsappNumber : smsNumber;
    const details = type === "isEmail" ? emailAddress : number;

    const send_details = {
      whatsapp_phone: whatsappNumber,
      phone: smsNumber,
    };

    handleSaveConsultation(
      "draft",
      "share",
      { [type]: true },
      send_details,
      () => {
        setWhatsappNumber("");
        setSmsNumber("");
        setEmailAddress("");
      }
    );
  };

  return (
    <div className="max-w-md mx-auto p-4 bg-white rounded-md shadow-md relative">
      {/* Close Icon */}
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onClick={onClose}
      >
        <FaTimes size={24} />
      </button>
      <h2 className="text-lg font-bold mb-4">Share Prescription</h2>

      {/* Whatsapp Sharing */}
      <div className="flex flex-col gap-3 mb-4">
        <div className="flex items-center gap-2">
          <FaWhatsappSquare className="text-green-600" size={24} />
          <label className="font-bold">WhatsApp</label>
        </div>
        <CuInput
          placeholder="Enter WhatsApp number"
          value={whatsappNumber}
          onChange={(e) => handleChange(e, "isWhatsapp")}
          required
        />
        <CuButton
          className="w-full h-9 rounded border cursor-pointer flex justify-center items-center"
          onClick={handleSendNotification("isWhatsapp")}
          isLoading={isSendNotificationLoading}
        >
          Send via WhatsApp
        </CuButton>
      </div>

      {/* SMS Sharing */}
      {/* <div className="flex flex-col gap-3 mb-4">
        <div className="flex items-center gap-2">
          <FaSms className="text-blue-600" size={24} />
          <label className="font-bold">SMS</label>
        </div>
        <CuInput
          placeholder="Enter SMS number"
          value={smsNumber}
          onChange={(e) => handleChange(e, "isSMS")}
          required
        />
        <CuButton
          className="w-full h-9 rounded border cursor-pointer flex justify-center items-center"
          onClick={handleSendNotification("isSMS")}
          isLoading={isLoading}
        >
          Send via SMS
        </CuButton>
      </div> */}

      {/* Email Sharing */}
      {/* <div className="flex flex-col gap-3 mb-4">
        <div className="flex items-center gap-2">
          <MdEmail className="text-red-600" size={24} />
          <label className="font-bold">Email</label>
        </div>
        <CuInput
          placeholder="Enter Email Address"
          value={emailAddress}
          onChange={(e) => handleChange(e, "isEmail")}
          required
        />
        <CuButton
          className="w-full h-9 rounded border cursor-pointer flex justify-center items-center"
          onClick={handleSendNotification("isEmail")}
          isLoading={isLoading}
        >
          Send via Email
        </CuButton>
      </div> */}
    </div>
  );
};

export default Share;
